<template>
  <modal v-if="show" :title="title" :extra-wide="extraWide" :z-index="400" @close="close">
    <alert v-if="infoText" type="info" :text="infoText" />
    <slot />
    <div id="button-container" :class="alignButtons ? 'align-' + alignButtons : null">
      <app-button
        v-if="confirmButtonShow"
        :data-qa="`${id}-confirm`"
        :disabled="disabled"
        @click="confirmAction"
      >
        {{ confirmButtonText ? confirmButtonText : i18n.t('/common/confirm') }}
      </app-button>
      <app-button
        v-if="cancelButtonShow"
        :data-qa="`${id}-cancel`"
        :button-class="cancelButtonClass"
        @click="cancelAction"
      >
        {{ cancelButtonText ? cancelButtonText : i18n.t('/common/cancel') }}
      </app-button>
      <slot name="buttons" />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
export default {
  components: {
    Modal,
    AppButton,
    Alert,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    infoText: {
      type: String,
      default: null,
    },
    confirmButtonText: {
      type: String,
      default: null,
    },
    cancelButtonText: {
      type: String,
      default: null,
    },
    cancelButtonClass: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    confirmButtonShow: {
      type: Boolean,
      default: true,
    },
    cancelButtonShow: {
      type: Boolean,
      default: true,
    },
    extraWide: {
      type: Boolean,
      default: false,
    },
    alignButtons: {
      type: String,
      default: null,
    },
  },
  emits: ['cancel', 'close', 'confirm'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    cancelAction() {
      this.$emit('cancel')
      this.close(null, true)
    },
    confirmAction() {
      this.$emit('confirm')
      this.close(null, true)
    },
    close(_, isAfterAction = false) {
      // To make it possible to add an action in the close event
      this.$emit('close', isAfterAction)
    },
  },
}
</script>

<style lang="scss" scoped>
#button-container {
  margin-top: 1rem;

  &.align-center {
    display: flex;
    justify-content: center;
  }
}
</style>
